module.exports = __webpack_public_path__ + "static/media/plate_yoke.ff6c8a90.webp";